import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { useSnackbar } from 'notistack';
import * as carApi from '../../lib/api/car';
import { logout } from '../../modules/auth';
import CarListForm from '../../components/carmng/CarListForm';

const CarMobileContainer = () => {
  const loginUser = JSON.parse(localStorage.getItem('user') || '{}');
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]); 
  const [useRows, setuseRows] = useState([]); 
  const [reservUserRows, setReservUserRows] = useState([]); 
  const [reservRows, setReservRows] = useState([]); 
  const [tabValue, setTabValue] = useState(0); 
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formatWithDay = (dateStr) => {
    if (!dateStr) return '-';
    try {
      const date = new Date(dateStr);
      return format(date, 'yyyy-MM-dd (eee) HH:mm', { locale: ko });
    } catch (e) { return dateStr; }
  };

  const [dates, setDates] = useState({
    start: new Date(new Date().setHours(0, 0, 0, 0)),
    end: new Date(new Date().setHours(23, 59, 59, 999)),
  });

  const fetchListData = useCallback(async () => {
  try {
    const baseParams = {
      ...(localStorage.getItem('loginMode') === 'car_service' && { usrUuid: loginUser?.usrUuid })
    };

    const reservParams = tabValue === 0 
      ? { 
          startDate: format(dates.start, 'yyyy-MM-dd HH:mm'), // dates.start 참조
          endDate: format(dates.end, 'yyyy-MM-dd HH:mm')      // dates.end 참조
        } 
      : baseParams;

    const [resUse, resHistory, resReservUser, resReserv] = await Promise.all([
      carApi.getCarUsageUseList(baseParams),
      carApi.getCarUsageList(baseParams),
      carApi.getCarReservList(baseParams),
      carApi.getCarReservList(reservParams),
    ]);

    if (isMounted.current) {
      setuseRows(resUse.data?.list || []);
      setRows(resHistory.data?.list || []);
      setReservUserRows(resReservUser.data?.list || []);
      setReservRows(resReserv.data?.list || []);
      console.log(resHistory.data?.list);
    }
  } catch (err) {
    if (isMounted.current) enqueueSnackbar('데이터 로드 실패', { variant: 'error' });
  }
}, [loginUser?.usrUuid, enqueueSnackbar, tabValue, dates]); 

  useEffect(() => {
    isMounted.current = true;
    fetchListData();
    return () => { isMounted.current = false; };
  }, [fetchListData]);


  const activeReservation = useMemo(() => {
    const now = new Date();

    return reservUserRows.find(res => {
      if (res.statusYn === 'N') return false;

      const safeStartStr = res.startDate.replace(/-/g, '/');
      const safeEndStr = res.endDate.replace(/-/g, '/');
      const start = new Date(safeStartStr);
      const end = new Date(safeEndStr);

      const bufferStart = new Date(start.getTime() - 30 * 60 * 1000);
      const isActive = now >= bufferStart && now <= end;

      return isActive;
    });
  }, [reservUserRows]);


  const ongoingRows = useMemo(() => rows.filter(item => !item.endDate || !item.afterMileage), [rows]);
  const completedRows = useMemo(() => rows.filter(item => item.endDate && item.afterMileage), [rows]);
  const hasOngoing = ongoingRows.length > 0;

  const handleStartStop = () => {
    if (hasOngoing) {
      navigate("/carusage/registration", { 
        state: { type: 'edit', data: { ...ongoingRows[0] } } 
      });
    } else {
      if (!activeReservation) {
        enqueueSnackbar('현재 시간에 예약된 차량 정보가 없습니다. 먼저 예약해주세요.', { variant: 'warning' });
        return;
      }
      navigate("/carusage/registration", { 
        state: { type: 'new', data: null, activeReservation: { ...activeReservation } } 
      });
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const statusCounts = useMemo(() => ({
    driving: useRows.filter(item => item.statusYn === 'S').length,
    available: useRows.filter(item => item.statusYn !== 'S').length
  }), [useRows]);

  return (
    <CarListForm 
      tabValue={tabValue}
      setTabValue={setTabValue}
      useRows={useRows}
      reservRows={reservRows}
      reservUserRows={reservUserRows}
      ongoingRows={ongoingRows}
      completedRows={completedRows}
      statusCounts={statusCounts}
      hasOngoing={hasOngoing}
      formatWithDay={formatWithDay}
      handleStartStop={handleStartStop}
      handleLogout={handleLogout}
      setDates= {setDates}
      dates = {dates}
    />
  );
};

export default CarMobileContainer;
